import jq from 'jquery';
import LoginSignup from '@shared/modal-login-signup';
import 'stellar';
import 'bootstrap';
import { getUserIdfromCookie } from '@shared/cookie';
import moduleQuickHire from '@shared/modal-hireme';
import {
  showHireMePromotionCopy,
  hireMeData,
  isNewUser,
  signupModalRequired,
  profileServerData,
  launchHireMe,
} from 'server-data/profile-logged-out';

const TIMEFORMAT = {
  hour: 'numeric',
  hour12: true,
};

let allowHireMeTracking = true;

/*
 * Return the value of a given query string variable
 * @param String the url ?XXX parameter
 * @returns String the value of a given parameter
 */
function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');

  for (let i = 0, len = vars.length; i < len; i++) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
}

/*
 * Display a modal view containing the quickhire form
 * @param Number hireUserID of the employee
 * @param String hireName username of the employee
 * @param Number hireAtRate hourly rate to hire the user at
 * @param String hireAvatar profile pic of the user
 * @returns undefined
 */
function openHiremeModalForm(hireUserID, hireName, hireAtRate, hireAvatar) {
  const params = {
    userID: hireUserID,
    username: hireName,
    hourlyrate: hireAtRate,
    avatar: hireAvatar,
    isNewUser,
  };

  if (typeof hireMeData !== 'undefined') {
    params.projectTitle = hireMeData.title;
    params.projectDescription = hireMeData.description;
    params.budget_period = hireMeData.budget_period;
  } else {
    // prefill based on params
    params.budget_period = 'fixed';
    params.projectTitle = urldecode(getQueryVariable('title'));
    params.projectDescription = urldecode(getQueryVariable('desc'));
    params.email = urldecode(getQueryVariable('email'));
    params.sourceType = urldecode(getQueryVariable('sourcetype'));
    params.sourceId = urldecode(getQueryVariable('sourceid'));
  }

  // Add fixed price param if 's' is present in the query string
  const fixedPrice = parseInt(getQueryVariable('s'), 10);
  if (typeof fixedPrice === 'number' && fixedPrice > 0) {
    params.fixed_budget = fixedPrice;
    params.budget_period = 'fixed';
  }

  // Add number of days if 'p' is present in the query string
  const daysDuration = parseInt(getQueryVariable('p'), 10);
  if (typeof daysDuration === 'number' && daysDuration > 0) {
    params.daysDuration = daysDuration;
    params.budget_period = 'fixed';
  }

  // Change appropriate project type if 'projectType' is present in query string
  const projectType = getQueryVariable('projectType');
  if (projectType === 'fixed' || projectType === 'hourly') {
    params.budget_period = projectType;
  }

  // The hireme promotion copy for Operation Termite/Downwork
  params.showHireMePromotionCopy = showHireMePromotionCopy;

  // This used to be a global variable the  wasn't set anywhere but we need it
  // to prevent user_auth_form in hireme-modal from breaking
  params.signupModalRequired = signupModalRequired;

  // Open hireme form
  moduleQuickHire.initForm(params);
}

/*
 * replace URLencoded spaces
 * @param String url the URLencoded string
 * @returns String with URLencoded spaces converted to normal spaces
 */
function urldecode(url) {
  if (typeof url === 'undefined') {
    return null;
  }
  return decodeURIComponent(url.replace(/\+/g, ' '));
}

/*
 * Bind stickyNav show / hide to scroll events once user scrolls past nav
 */
function initStickyNav() {
  const ownerId = profileServerData.userId;
  if (ownerId.toString() !== getUserIdfromCookie()) {
    let throttleTimeout;
    const $bar = jq('#sticky-bar');
    const $barStart = jq('#sticky-start');
    const barHeight = $bar.height();
    const barTop = $barStart.offset().top;
    throttleTimeout = null;

    // Listen to scroll event and make header sticky when we scroll past a
    // certain point
    jq(window).scroll(() => {
      clearTimeout(throttleTimeout);
      throttleTimeout = setTimeout(() => {
        const scrolltop = jq(document).scrollTop();
        if (scrolltop >= barTop + barHeight / 2) {
          $bar.removeClass('is-hidden');
        } else if (scrolltop <= barTop + barHeight / 2) {
          $bar.addClass('is-hidden');
        }
      }, 0);
    });
  }
}

/**
 * @description Display and initialise the expand / hide button if a section is
 * longer than a certain length
 *
 * @param String wrapperSelector css selector for the wrapper element which
 * contains max-height of the unexpanded view
 * @param String contentSelector css selector for the content we are
 * hiding/showing
 * @param String expandButtonSelector css selector for the show/hide button
 * @param Number the amount of px to show when clicked
 * @param Boolean hide the button when clicked if true
 * @param String containerSelector css selector for the container item all of
 * the above items live inside
 *
 * @returns undefined
 */
function initExpander(
  wrapperSelector,
  contentSelector,
  expandButtonSelector,
  expandHeight,
  hideButtonOnExpand,
  containerSelector,
) {
  if (typeof containerSelector === 'undefined') {
    containerSelector = 'body';
  }

  // cache jQuery selectors
  const $container = jq(containerSelector);
  const $expandButton = $container.find(expandButtonSelector);
  const $wrapper = $container.find(wrapperSelector);
  const $content = $wrapper.find(contentSelector);
  const contentHeight = $content.height();

  if (contentHeight > $wrapper.height()) {
    $expandButton.click(function(e) {
      e.preventDefault(); // block default click functionality

      if (typeof expandHeight === 'undefined') {
        $wrapper.toggleClass('is-expanded'); // toggle expand if height not set
      } else {
        $wrapper.css('max-height', `${$wrapper.height()}${expandHeight}px`);
      }
      if (hideButtonOnExpand && contentHeight <= $wrapper.height()) {
        jq(this).hide();
      }
    });

    // Only show button if there is overflow content
    $expandButton.removeClass('is-hidden');
  }
}

/*
 * Enable tabbing functionality for badges
 * @returns undefined
 */
function initBadgesTabs() {
  jq('#badge-tabs a').click(function(e) {
    e.preventDefault();
    jq(this).tab('show');
  });
}

/*
 * Display the freelancer's local time to user (check against browser time
 * and local offset as pages are cached for 24 hours)
 * @param Number offsetMins The difference in minutes between desired time
 * and browser time
 * @returns undefined
 */
function initLocalTime(offsetMins) {
  // if we have a timezone offset, display the local time for the profile owner
  if (offsetMins !== null && !Number.isNaN(offsetMins)) {
    const $timeContainer = jq('#local-time');
    const $timeElement = $timeContainer.find('time');

    $timeElement.html(getTimeString(offsetMins));
    $timeContainer.removeClass('is-hidden');
  }
}

/*
 * Lookup a time relative to browser time
 * @param Number offsetMins The difference in minutes between desired time and
 * browser time
 * @returns String The adjusted and formatted timestring, based on the Object
 * constant
 */
function getTimeString(offsetMins) {
  const now = new Date();
  const offsetFromBrowserTime =
    parseInt(offsetMins, 10) + now.getTimezoneOffset();
  const offsetTime = new Date(now.getTime() + offsetFromBrowserTime * 60000);
  return offsetTime
    .toLocaleTimeString(navigator.language, TIMEFORMAT)
    .replace(' ', '');
}

/*
 * Open hireme form if params supplied and bind click events to hireme buttons
 * @param Number hireUserID of the employee
 * @param String hireName username of the employee
 * @param Number hireAtRate hourly rate to hire the user at
 * @param String hireAvatar profile picture of the freelancer
 * @returns undefined
 */
function initHireMe(hireUserID, hireName, hireAtRate, hireAvatar) {
  // Check if `hireme` parameter is present in query string. If yes, open the
  // hireme modal form on page load
  const isHireme = getQueryVariable('hireme');
  const action = getQueryVariable('action');

  if (
    (typeof isHireme !== 'undefined' && isHireme === 'true') ||
    (typeof action !== 'undefined' && action === 'hireme')
  ) {
    // Open modal form including GET parameters in configuration
    openHiremeModalForm(hireUserID, hireName, hireAtRate, hireAvatar);
  }

  // Open hireme form when user clicks on the 'Hire me' button
  jq(document).on('click', '.hireme-modal-trigger', e => {
    trackHiremeCTA(e);
    openHiremeModalForm(hireUserID, hireName, hireAtRate, hireAvatar);
  });
}

/**
 * Track clicks on hireme CTAs
 */
function trackHiremeCTA(e) {
  // tracking
  if (allowHireMeTracking) {
    const source = jq(e.target).attr('hireme-source');
    const event = jq(e.target).attr('hireme-event');
    const label = jq(e.target).attr('hireme-label');

    if (source || event) {
      allowHireMeTracking = false;
    }

    if (source) {
      _ttref.push(
        ['_clearEntrypoint', 'ProjectHireMe'],
        ['_setCookie', `ProjectHireMe_${source}`],
      );
    }

    if (event) {
      const data = ['_trackEvent', 'ProjectHireMe', event];
      if (label) {
        data.push(label);
      }
      _ttref.push(data);
    }

    setTimeout(() => {
      allowHireMeTracking = true;
    }, 100);
  }
}

/*
 * Initialise scrolling logic
 * @returns undefined
 */
function initScrollToTarget() {
  // Animated scroll from an anchor to when an element is clicked on
  // data-anchor-scroll <a> tags
  jq('[data-anchor-scroll]')
    .find('a[href*=#]:not([href=#])')
    .click(function() {
      // check link is on page
      if (
        window.location.pathname.replace(/^\//, '') ===
          this.pathname.replace(/^\//, '') &&
        window.location.hostname === this.hostname
      ) {
        return scrollToID(this.hash);
      }
    });

  // scroll if page parameters supplied
  const pageParam = getQueryVariable('page');
  if (typeof pageParam !== 'undefined') {
    switch (pageParam) {
      case 'portfolio':
        jq('#sticky-bar').addClass('is-sticky');
        scrollToID('#profile-portfolio');
        break;
      case 'resume':
        jq('#sticky-bar').addClass('is-sticky');
        scrollToID('#profile-experience');
        break;
      case 'ratings':
      // fallthrough
      case 'exams':
        jq('#sticky-bar').addClass('is-sticky');
        scrollToID('#profile-reviews');
        break;
      case 'badges':
        jq('#sticky-bar').addClass('is-sticky');
        scrollToID('#profile-badges');
        break;
      case 'overview':
        scrollToID('#profile-top');
        break;
      default:
        // nothing
        break;
    }
  }
}

/*
 * Animated scroll from an anchor to it's target
 * @param IdWithHash the '#id' element to scroll to
 * @returns undefined
 */
function scrollToID(IdWithHash) {
  let target = jq(IdWithHash);
  target = target.length ? target : jq(`[name=${IdWithHash.slice(1)}]`);
  if (target.length) {
    jq('html,body').animate(
      {
        // scroll location offset by sticky bar
        scrollTop: target.offset().top - 100,
      },
      750,
    );
    return false;
  }
}

/*
 * Display online dot and text depending on login status of profile owner
 * @param Boolean isOnline if the user is online
 * @param Number lastOnline in seconds since UNIX epoch
 * @returns undefined
 */
function setOnline(isOnline, lastOnline) {
  const $container = jq('#profile-status');
  const $onlineText = $container.find('#online-text');
  const $offlineText = $container.find('#offline-text');
  const $dot = $container.find('.online-status');

  if (isOnline) {
    $dot.attr('data-last-online', '');
    $dot.attr('data-tooltip-state', 'success');
    $dot.attr('data-status', 'online');
    $container.attr('data-status', 'online');
    $onlineText.removeClass('is-hidden');
    $offlineText.addClass('is-hidden');
  } else {
    $dot.attr(
      'data-last-online',
      new Date(lastOnline * 1000).toLocaleString(
        navigator.language,
        TIMEFORMAT,
      ),
    );
    $dot.attr('data-tooltip-state', 'disabled');
    $dot.attr('data-status', 'offline');
    $container.attr('data-status', 'offline');
    $onlineText.addClass('is-hidden');
    $offlineText.removeClass('is-hidden');
  }

  $dot.removeClass('is-hidden');
  $container.removeClass('is-hidden');
}

/*
 * retrieve online/offline status on load
 * @param Number userid lookup and display online status of this user
 * @returns undefined
 */
function initOnlineOffline(userid) {
  // Retrieve the online status and last login time for the profile owner
  jq.ajax({
    type: 'GET',
    data: {
      user_id: userid,
    },
    url: '/ajax/user/isOnline.php',
    success(response) {
      if (
        typeof response.result !== 'undefined' &&
        typeof response.result.online !== 'undefined'
      ) {
        setOnline(response.result.online === true, response.result.last_login);
      }
    },
  });
}

/*
 * Bind login / signup modal display to trigger elements
 * @returns undefined
 */
function initLoginSignup() {
  // new signup modal
  jq('.signup-modal-trigger').on('click', e => {
    const loginSignup = new LoginSignup({
      el: jq('#default-modal-placeholder'),
    });
    e.preventDefault();
    loginSignup.setBackdrop();
    loginSignup.showSignup();
  });
}

function initBtnDropdown() {
  jq('.btn-dropdown-trigger').on('click', e => {
    jq('.btn-dropdown').toggleClass('is-open');
    e.preventDefault();
    e.stopPropagation();
    jq(document).click(() => {
      jq('.btn-dropdown').removeClass('is-open');
    });
  });
}

/*
 * Load portfolio functionality appropriate to login status
 */
function initEvents(
  profileUserID,
  profileUsername,
  profileHourlyRate,
  profileTimeOffset,
  isLoggedIn,
  profileAvatar,
) {
  initLoginSignup();
  initLocalTime(profileTimeOffset);
  initOnlineOffline(profileUserID);
  initHireMe(profileUserID, profileUsername, profileHourlyRate, profileAvatar);
  initScrollToTarget();
  initStickyNav();
  initBtnDropdown();

  // Initialise Parallax effect for cover image
  jq.stellar({
    verticalOffset: 64,
  });

  const $skills = jq('#skills').find('li');
  const expandHeight =
    4 *
    (parseInt($skills.css('height'), 0) +
      parseInt($skills.css('margin-bottom'), 0));
  initExpander(
    '#profile-skills-wrapper',
    '#skills',
    '#expand-skills',
    expandHeight,
    true,
    '#profile-skills',
  );

  initBadgesTabs();

  // init tooltips
  jq('[data-toggle="tooltip"]').tooltip();
  jq('#default-header').attr('data-state', 'static');

  if (launchHireMe) {
    trackHiremeCTA(jq('.hireme-modal-trigger'));
    openHiremeModalForm(
      profileUserID,
      profileUsername,
      profileHourlyRate,
      profileAvatar,
    );
  }
}

//* ************* Executed on load *******************
jq(document).ready(() => {
  const data = profileServerData;
  initEvents(
    data.userId,
    data.username,
    data.hourlyRate,
    data.timeOffset,
    data.isLoggedIn,
    data.about.avatar,
  );
});

export default {
  initEvents,
};
